import { render, staticRenderFns } from "./AddNotificationsExtra.vue?vue&type=template&id=7ce9bd6e&scoped=true&"
import script from "./AddNotificationsExtra.vue?vue&type=script&lang=js&"
export * from "./AddNotificationsExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce9bd6e",
  null
  
)

export default component.exports